<template>
  <div class="news-detail">
    <common-header is-scrolled="true" :current-section="'news'" />
    
    <div class="detail-container">
      <!-- 标题部分 -->
      <div class="news-header">
        <h1>{{ $t('news.article56.content.title') }}</h1>
        <div class="news-date">{{ $t('news.article56.content.date') }}</div>
      </div>

      <!-- 文字描述部分 -->
      <div class="news-content">
        <!-- 第一部分：两张图片和文字 -->
        <div class="news-section">
          <div class="image-group">
            <img src="@/assets/xq/1.gif" alt="动态展示" class="news-image" />
            <img src="@/assets/xq/2.jpg" alt="成果展示" class="news-image" />
          </div>
          <div class="news-text">
            {{ $t('news.article56.content.text')[0] }}
          </div>
        </div>
        
        <!-- 第二部分：第三张图片和详细文字 -->
        <div class="news-section">
          <img src="@/assets/xq/3.jpg" alt="系统展示" class="news-image" />
          <div class="news-text">
            {{ $t('news.article56.content.text')[1] }}
          </div>
        </div>

        <!-- 第三部分：第四张图片 -->
        <div class="news-section">
          <img src="@/assets/xq/4.jpg" alt="系统展示" class="news-image" />
        </div>

       
      </div>
    </div>

    <common-section type="footer" id="contact" />
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader.vue';
import CommonSection from '@/components/CommonSection.vue';

export default {
  name: 'NewsDetail56',
  components: { CommonHeader, CommonSection },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style lang="scss" scoped>
.news-detail {
  .detail-container {
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 100px;
    padding: 40px 20px;
  }

  .news-content {
    background: #fff;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  .news-header {
    text-align: center;
    margin-bottom: 40px;

    h1 {
      font-size: 32px;
      color: #333;
      margin-bottom: 20px;
      font-weight: 600;
    }

    .news-date {
      color: #666;
      font-size: 16px;
    }
  }

  .news-section {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .image-group {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;
  }

  .news-image {
    width: 100%;
    max-width: 800px;
    height: auto;
    margin: 0 auto;
    display: block;
    border-radius: 8px;
  }

  .news-text {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    text-align: justify;
    margin: 20px 0;
    white-space: pre-line;
  }

  .credits {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #eee;

    h3 {
      font-size: 18px;
      color: #333;
      margin-bottom: 16px;
    }

    p {
      font-size: 16px;
      color: #666;
      line-height: 1.6;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media (max-width: 768px) {
  .news-detail {
    .detail-container {
      padding: 20px;
      margin-top: 80px;
    }

    .news-content {
      padding: 20px;
    }

    .news-header {
      h1 {
        font-size: 24px;
      }
    }

    .news-text {
      font-size: 15px;
    }

    .credits {
      h3 {
        font-size: 16px;
      }

      p {
        font-size: 14px;
      }
    }
  }
}
</style> 